import AmpersandModel from 'ampersand-model';

//import Moment from 'moment';

module.exports = AmpersandModel.extend({
    idAttribute: "id",

    props: {
        id: 'string',
        tileType: 'number',
        sortPosition: 'number',
        companyId: 'string',
        data: 'object',
        target: 'any'
    }
});